import onPageReady from './utils/onPageReady';
import openLinksInNewTab from './utils/openLinksInNewTab';
import polyfill from './polyfills/polyfill-loader';

const sentryDsn = null;

function initialise() {
    openLinksInNewTab();
    if (sentryDsn) {
        import(/* webpackChunkName: "sentry" */ './modules/sentry.js')
            .then(({ default: sentry }) => {
                sentry.init(sentryDsn);
            });
    }

    /*  Lazy loading  ------------------------- */
    const lazyElems = document.querySelector('.lazyload');
    if (lazyElems) {
        import('lazysizes');
    }

    /*  Mobile Menu  ------------------------- */
    const mobileNavEl = document.querySelector('.mobile-nav');
    if (mobileNavEl) {
        import(/* webpackChunkName: "mobile-nav" */ './modules/mobile.nav.js')
            .then(({ default: MobileNav }) => {
                new MobileNav(mobileNavEl);
            });
    }

    /*  Tables  ------------------------------ */
    const tables = document.querySelectorAll('table');
    if (tables.length > 0) {
        import(/* webpackChunkName: "tables" */ './modules/responsive-tables.js')
            .then(({ default: tablesInit }) => {
                tablesInit([...tables]);
            });
    }

    /*  Collapsibles  ------------------------ */
    const collapsibleEls = document.querySelectorAll('[data-collapse-control], .collapse-control');
    if (collapsibleEls.length > 0) {
        import(/* webpackChunkName: "collapsible" */ './modules/collapsible.js')
            .then(({ default: collapsibleInit }) => {
                collapsibleInit([...collapsibleEls]);
            });
    }

    /*  Resource Listing Filter  ------------- */
    const resourceFiltersToggle = document.querySelectorAll('[data-resource-filter-toggle]');
    if (resourceFiltersToggle.length > 0) {
        import(/* webpackChunkName: "resource-filters" */ './modules/resource-filters.js')
            .then(({ default: resourceFiltersInit }) => {
                resourceFiltersInit(resourceFiltersToggle[0]);
            });
    }

    /*  Parallax  ------------- */
    const parallaxEls = document.querySelectorAll('.js-parallax');
    if (parallaxEls.length > 0) {
        import(/* webpackChunkName: "parallax" */ './modules/parallax.js')
            .then(({ default: parallaxInit }) => {
                parallaxInit([...parallaxEls]);
            });
    }

    import(/* webpackChunkName: "header" */ './modules/header')
        .then(({ default: init }) => {
            init();
        });

    /*  Simple pagination  ------------- */
    const listingElem = document.querySelectorAll('[data-listing]');
    if (listingElem.length > 0) {
        import(/* webpackChunkName: "simple-pagination" */ './modules/pagination.js')
            .then(({ default: paginationInit }) => {
                paginationInit(listingElem[0]);
            });
    }

    /*  Simple pagination  ------------- */
    const subscriptionForm = document.querySelectorAll('#subscription-form');
    if (subscriptionForm.length > 0) {
        import(/* webpackChunkName: "subscription-form" */ './modules/subscription-cta.js')
            .then(({ default: subscriptionInit }) => {
                subscriptionInit(subscriptionForm[0]);
            });
    }

    /*  Glossary items  --------------------- */
    const glossaryElms = document.querySelectorAll('[data-glossary-term-id]');
    if (glossaryElms.length > 0) {
        import(/* webpackChunkName: "glossary" */ './modules/glossary.js')
            .then(({ default: glossariesInit }) => {
                glossariesInit([...glossaryElms]);
            });
    }

    /*  Dashboard app  ------------------------ */
    const dashboardAppEl = document.getElementById('srt-dashboard-app-container');
    if (dashboardAppEl) {
        import(/* webpackChunkName: "dashboardApp" */ './dashboard/index.js')
            .then(({ default: dashInit }) => {
                dashInit(dashboardAppEl);
            });
    }

    /*  Assessment app  ------------------------ */
    const assessmentAppEl = document.getElementById('srt-assessment-app-container');
    if (assessmentAppEl) {
        import(/* webpackChunkName: "dashboardApp" */ './assessment/index.js')
            .then(({ default: dashInit }) => {
                dashInit(assessmentAppEl);
            });
    }
}

polyfill().then(() => onPageReady(initialise));
